module.exports = __webpack_public_path__ + "static/media/customerTile.667faed6.jpg";